export const config = {
  enableScrollSmoother: true, // ScrollSmootherを有効にするかどうか
  enableBarba: true,          // BarbaJSを有効にするかどうか
  recaptchaPublicKey: '6Lcf7_8pAAAAAKoHV0tss1rVmdqNyY4gZNq0n1EC', // reCAPTCHAの公開鍵（PHP側に秘密鍵もあるので変更等注意）
};